module.exports = __webpack_public_path__ + "static/img/bg_share_mask.c5faadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_share_mask.png
// module id = se77
// module chunks = 1